import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  MultipleUserStoriesContext,
  UserStoriesLoaderContext,
} from "../MultipleUserStoryPage";
import MultipleEvaluationSummary from "../../output-components/user-story/MultipleEvaluationSummary";
import MultipleUserStoriesComponent from "../../output-components/user-story/MultipleUserStoriesComponent";
import MultipleRefinedUserStory from "../../output-components/user-story/MutilpleRefinedUserStory";
import { Box, Typography } from "@mui/material";
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import FullscreenToggle from "../../custom-components/FullScreenToggle";
// import MultipleUseCase from "../../output-components/user-story/MultipleUseCaseComponent";

const MultiUserStoryOutputPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    multipleUserStories,
    setMultipleUserStories,
    setSelectedUserStories,
    multipleEvaluationSummary,
    setMultipleEvaluationSummary,
    multipleRefinedUserStory,
    setMultipleRefinedUserStory,
    setSelectedRefinedUserStories,
    multipleUseCases,
    setMultipleUseCases,
    setSelectedUseCases,
  } = useContext(MultipleUserStoriesContext);

  useEffect(() => {
    if (!location.state?.userStories || !location.state.userStories.length) {
      return navigate("/dashboard/userstory/input");
    }

    console.log("Location state:", location.state);
    setMultipleUserStories(location.state.userStories || []);
    setSelectedUserStories(location.state.selectedUserStories || []);
    setMultipleEvaluationSummary(location.state.multiEvaluationSummary || []);
    setMultipleRefinedUserStory(location.state.multipleRefinedUserStory || []);
    setSelectedRefinedUserStories(
      location.state.selectedRefinedUserStories || []
    );
    setMultipleUseCases(location.state.multipleUseCases || []);
    setSelectedUseCases(location.state.selectedMultipleUseCases || []);
  }, [location.state, navigate]);

  return (
    <Box
      sx={{
        width: "100%",
        mx: "auto",
        px: { xs: 1, sm: 2, md: 3 },
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pb: "30px", // Padding for the fixed footer
      }}
    >
      {/* Inner Container */}
      <Box
        sx={{
          width: "100%",
          mx: "auto",
          maxWidth: {
            xs: "100%",
            sm: "100%",
            md: "95%",
            lg: "90%",
            xl: "1266px",
          },
          my: 2,
          "& > *:not(:last-child)": {
            mb: 2,
          },
        }}
      >
        {/* Sticky Header */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          // position="sticky"
          top={0}
          zIndex={10}
          py={1}
          bgcolor="#f6f3f2"
        >
          <Box display="flex" alignItems="center">
            <AutomateIcon style={{ marginRight: 4 }} />
            <Typography
              variant="body2"
              color="text.secondary"
              fontSize={12}
              sx={{ mt: 0.5 }}
            >
              Refine user stories to create detailed requirements.
            </Typography>
          </Box>
          {/* <FullscreenToggle /> */}
        </Box>

        {/* Output Components */}
        {!!multipleUserStories.length && <MultipleUserStoriesComponent />}
        {!!multipleEvaluationSummary.length && <MultipleEvaluationSummary />}
        {!!multipleRefinedUserStory.length && <MultipleRefinedUserStory />}
        {/* {!!multipleUseCases.length && <MultipleUseCase />} */}
      </Box>

      {/* Fixed Footer */}
      <Box
        component="footer"
        sx={{
          width: "100%",
          // maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="text.secondary">
          Use QMentisAI™ with human supervision, as with all generative AI
          tools.
        </Typography>
      </Box>
    </Box>
  );
};

export default MultiUserStoryOutputPage;
